import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export default function UserAdminRedirect() {
    useEffect(() => {
        window.localStorage.removeItem("lastPath");
    }, []);

    window.localStorage.removeItem("lastPath");
    return <Navigate to="/launcher" replace />;
}
